// Canonical reorderable-column key list for the public results table.
// Kept in sync with `_COLUMN_ORDER_KEYS` in apps/api/app/schemas/branding.py
// and `COLUMN_KEYS` in apps/admin/src/pages/Branding/components/DisplaySettingsTab/columnDefs.ts.
export type ColumnKey =
  | "quality"
  | "imprint"
  | "payment"
  | "license"
  | "publishingModel";

export const DEFAULT_COLUMN_ORDER: ColumnKey[] = [
  "quality",
  "imprint",
  "payment",
  "license",
  "publishingModel",
];

/**
 * Reconciles a stored `branding.column_order` against the columns actually
 * applicable for this account (i.e. drops "quality" when the account has no
 * quality_lists extension), and appends any applicable column missing from
 * the stored value. Falls back cleanly to the default order when the stored
 * value is absent, invalid, incomplete, or contains unknown keys.
 */
export function resolveColumnOrder(
  storedOrder: string[] | undefined,
  hasQualityExtension: boolean,
): ColumnKey[] {
  const applicable = DEFAULT_COLUMN_ORDER.filter(
    (key) => key !== "quality" || hasQualityExtension,
  );
  const applicableSet = new Set(applicable);
  const fromStored = Array.isArray(storedOrder)
    ? storedOrder.filter((key): key is ColumnKey =>
        applicableSet.has(key as ColumnKey),
      )
    : [];
  const seen = new Set(fromStored);
  const missing = applicable.filter((key) => !seen.has(key));
  return [...fromStored, ...missing];
}
